type UseDoWhileOptions = {
  /**
   * The interval in milliseconds
   * @default 2000
   */
  interval?: number
  callback: (stop: VoidFunction) => void
  onTimeout: VoidFunction
  /**
   * A number to stop the loop after a certain number of iterations
   * @default 10
   */
  counterTillTimeout?: number
  immediate?: boolean
}

export const useDoWhile = ({
  interval = 2000,
  callback,
  onTimeout,
  counterTillTimeout = 10,
  immediate = false,
}: UseDoWhileOptions) => {
  const timerController = useInterval(interval, {
    controls: true,
    immediate,
    callback: (counterValue) => {
      if (counterValue >= counterTillTimeout) {
        onTimeout()
        stop()
        return
      }

      callback?.(stop)
    },
  })

  function stop() {
    timerController.pause()
    timerController.reset()
  }

  return { start: timerController.resume }
}
